import { useSendFiatList } from '~api'

export const useSendFiatAvailable = () => {
    const sendFiatList = useSendFiatList()
    const isFiatLoading = sendFiatList.isLoading
    const isFiatAvailable = !!sendFiatList.data?.length

    return { isFiatLoading, isFiatAvailable }
}
